import { paymentApi } from './paymentApi';

export const surveyLimitService = {
  // Check if a user can create a new survey based on the new requirements
  canCreateSurvey: async (userData, auth) => {
    const { isAdmin, credits } = auth;
    
    // Admins can always create surveys
    if (isAdmin) return { canCreate: true };
    
    // Get user attributes from Cognito
    const userDetails = await paymentApi.getUserDetails();
    const lastUsedDate = userDetails.lastUsedApp ? new Date(userDetails.lastUsedApp) : null;
    const subscriptionUntil = userDetails.subscriptionUntil ? new Date(userDetails.subscriptionUntil) : null;
    const currentDate = new Date();
    const hasSubscription = subscriptionUntil && subscriptionUntil > currentDate;
    
    // Has subscription and at least 1 credit
    if (hasSubscription && credits > 0) {
      return { canCreate: true };
    }
    
    // No subscription, but has credits and last used date > 5 minutes ago
    if (!hasSubscription && credits > 0) {
      // If no last used date, they can create
      if (!lastUsedDate) {
        return { canCreate: true };
      }
      
      // Calculate minutes since last use
      const minutesSinceLastUse = Math.floor((currentDate - lastUsedDate) / (1000 * 60));
      
      if (minutesSinceLastUse > 5) {
        return { canCreate: true };
      } else {
        return {
          canCreate: false,
          message: 'Please wait at least 5 minutes between research creations.'
        };
      }
    }
    
    // Not eligible - no credits
    return {
      canCreate: false,
      message: 'You need credits to create a survey. Subscribe to get weekly credits or wait for your free research credit.'
    };
  },
  
  // Update last used app date when survey is generated
  updateLastUsedDate: async () => {
    try {
      const currentDate = new Date().toISOString();
      await paymentApi.updateUserAttributes({
        'custom:last_used_app': currentDate,
        'custom:last_free_research': currentDate
      });
    } catch (error) {
      console.error('Failed to update last used date:', error);
    }
  },
  
  // Charge user for additional survey
  chargeSurvey: async () => {
    try {
      const confirmed = window.confirm('This will use up 1 research credit. Do you want to continue?');
      
      if (!confirmed) {
        return { success: false, message: 'Survey generation cancelled.' };
      }
      
      const userDetails = await paymentApi.getUserDetails();
      
      if (userDetails.walletBalance < 100) {
        return { 
          success: false, 
          message: 'Insufficient credits.',
          redirectToTopUp: true
        };
      }
      
      // Deduct credits for the survey
      await paymentApi.updateUserAttributes({
        'custom:wallet_balance': (parseInt(userDetails.walletBalance) - 20).toString(),
        'custom:last_used_app': new Date().toISOString()
      });
      
      return { success: true };
    } catch (error) {
      // console.error('Failed to charge for survey:', error);
      return { success: false, message: 'An error occurred while processing payment.' };
    }
  }
};